import { combineReducers } from 'redux';

import { signinReducer, signupReducer, resetPasswordReducer } from './User.reducers';
import { companyCreationReducer } from './Company.reducers';
import { createMomentumReducer, listFiltersReducer, listMomentumsReducer, listChannelsReducer } from './Momentum.reducers';
import { alertReducer } from './Alert.reducers';
import { storeDomainReducer, listDomainsReducer, changeDomainReducer } from './Domain.reducers';
import { listDashboardData } from './Dashboard.reducers';
import { channelsReducer, createChannel } from './Channel.reducers';
import { settingsReducer } from './Settings.reducers';
import { listMediaReducer } from './Media.reducers';
import { listDcmsReducer, createDcmReducer, editDcmReducer } from './Dcm.reducers';

const appReducers = combineReducers({
  listDashboardData,
  signinReducer,
  signupReducer,
  resetPasswordReducer,
  companyCreationReducer,
  alertReducer,
  changeDomainReducer,
  storeDomainReducer,
  listDomainsReducer,
  listFiltersReducer,
  listMomentumsReducer,
  listChannelsReducer,
  createMomentumReducer,
  settingsReducer,
  channelsReducer,
  createChannel,
  listMediaReducer,
  listDcmsReducer,
  editDcmReducer,
  createDcmReducer
});

const initialState = appReducers({}, {});

const rootReducer = (state, action) => {
  if ( action.type === "RESET_STORE") {
    state = initialState;
  }

  return appReducers(state, action);
}

export default rootReducer;
